import { render, staticRenderFns } from "./ReportsHome.vue?vue&type=template&id=f0c51d66&"
import script from "./ReportsHome.vue?vue&type=script&lang=js&"
export * from "./ReportsHome.vue?vue&type=script&lang=js&"
import style0 from "./ReportsHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports